<div class="main-container">

  <div style="display: grid;">
    <img src="assets/img/logo-home.png" alt="Logo de Qloud" style="max-width: 30%; margin: 0 auto;">
  </div>

  <br /><br />

  <mat-card class="loginBox">
    <mat-card-content>
      <form [formGroup]="changePasswordForm" class="form">
        <h2>{{ 'createCredentials.title' | translate }}</h2>
        <mat-form-field class="full-width">
          <mat-label>{{ 'login.username.label' | translate }}</mat-label>
          <input matInput formControlName="username"
            [ngModel]="username">
        </mat-form-field>
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'changePassword.newPassword.label' | translate }}</mat-label>
          <input matInput type="password"
            formControlName="newPassword" [(ngModel)]="newPassword" autocomplete="new-password" required
            [errorStateMatcher]="matcher">
          @if (changePasswordForm.get('newPassword').hasError('required')) {
            <mat-error>
              {{ 'changePassword.newPassword.error.required' | translate }}
            </mat-error>
          }
          @if (changePasswordForm.get('newPassword').hasError('pattern')) {
            <mat-error>
              {{ 'changePassword.newPassword.error.pattern' | translate }}
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'changePassword.confirmPassword.label' | translate }}</mat-label>
          <input matInput type="password"
            formControlName="confirmPassword" [(ngModel)]="confirmPassword" autocomplete="new-password" required
            [errorStateMatcher]="matcher">
          <mat-error>
            {{ 'changePassword.confirmPassword.error.notMatch' | translate }}
          </mat-error>
        </mat-form-field>
        @if (message) {
          <p>
            {{ message }}
          </p>
        }
        @if (error) {
          <p class="error">
            {{ error }}
          </p>
        }

      </form>
    </mat-card-content>

    <mat-card-actions>
      <button mat-raised-button (click)="changePassword()" color="primary">{{ 'button.send' | translate }}</button>
    </mat-card-actions>
  </mat-card>

  <a class="under-card-link" (click)="backLogin()">
    {{ 'button.goBack' | translate }}
  </a>

</div>
